import { render, staticRenderFns } from "./Unilateral-api.vue?vue&type=template&id=14050d31&"
import script from "./Unilateral-api.vue?vue&type=script&lang=js&"
export * from "./Unilateral-api.vue?vue&type=script&lang=js&"
import style0 from "./Unilateral-api.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports